import { useEffect } from 'react';
import { useIsConsumerSession } from '@/hooks/use-app-mode';
import { CONSUMER_STEPS, type ConsumerStepId } from '../lib/steps';
import { useConsumerPlan } from './use-consumer-plan';
import { markConsumerFlowVisited } from './use-consumer-resume';

/**
 * Saves the screen a returning consumer should land on, and notes this session has been here.
 * An advisor looking at the flow doesn't move the consumer's place in it.
 */
export function useRememberStep(clientId: string, step: ConsumerStepId) {
  const isConsumer = useIsConsumerSession();
  const { plan, updatePlan } = useConsumerPlan(clientId);
  const shouldRemember = isConsumer && !!plan && CONSUMER_STEPS[step].resumable && plan.lastStep !== step;

  useEffect(() => {
    if (shouldRemember) updatePlan({ lastStep: step });
  }, [shouldRemember, step, updatePlan]);

  useEffect(() => markConsumerFlowVisited(clientId), [clientId]);
}
